var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSucces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 72.5C57.0538 72.5 72.5 57.0538 72.5 38C72.5 18.9462 57.0538 3.5 38 3.5C18.9462 3.5 3.5 18.9462 3.5 38C3.5 57.0538 18.9462 72.5 38 72.5Z",
    fill: "#B9FFD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9993 65.0827C52.9571 65.0827 65.0827 52.9571 65.0827 37.9993C65.0827 23.0416 52.9571 10.916 37.9993 10.916C23.0416 10.916 10.916 23.0416 10.916 37.9993C10.916 52.9571 23.0416 65.0827 37.9993 65.0827Z",
    fill: "#12CF5D",
    stroke: "#44FC8E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1199 30.6871L33.0298 45.8085L27.5 39.6504",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucces);
export default __webpack_public_path__ + "static/media/Succes.84609374b90bfec6d7f50bedf9c76541.svg";
export { ForwardRef as ReactComponent };